import { Component } from '@angular/core';

import { AbstractCellComponent } from '@camelot/core';
import { TranslatePipe } from '@camelot/translation';

import { CamTranslationProject } from '../../../../../translation.service';
import { Periodicity } from '../../../services/dto/periodicity';

export const periodicityLabel = (periodicity: Periodicity) =>
  `project.billings.periodicity.${Periodicity[periodicity]?.toLowerCase() ?? 'unknown'}`;

@Component({
  host: { 'data-cid': 'grid-billing-periodicity-cell' },
  imports: [TranslatePipe],
  selector: '',
  template: `{{ this.value ? periodicityLabel(this.value) : ('' | translate) }}`,
})
export class GridBillingPeriodicityCellComponent extends AbstractCellComponent<any, Periodicity> {
  periodicityLabel = periodicityLabel;
  constructor() {
    super();
    CamTranslationProject.getInstance();
  }
}
